/* RayoCommerce OS — comportamiento propio de la Landing SafeFry Freidora de Canasta.
   Namespace rc-sf-* — no modifica rc-scripts.js ni rc-printycat.js compartidos.
   Patrón heredado y verificado en producción (PrintyCat, 2026-07-04):
   ver knowledge/commerce/releasit/integracion-releasit-cod.md */
(function () {
  function initSticky() {
    var bar = document.querySelector('[data-rc-sf-sticky]');
    var trigger = document.querySelector('[data-rc-sf-sticky-trigger]');
    if (!bar || !trigger || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-rc-sf-visible', !entry.isIntersecting);
          document.body.classList.toggle('rc-sf-cta-lifted', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(trigger);
  }

  function initBuy() {
    var triggers = document.querySelectorAll('[data-rc-pc-buy], [data-rc-sf-buy]');
    if (!triggers.length) return;
    triggers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        // Dispara el botón real de Releasit (abre el formulario COD ya poblado). Cero rutas a carrito nativo.
        var rel = document.querySelector('#_rsi-buy-now-button, ._rsi-buy-now-button');
        if (rel) { rel.click(); return; }
        // Respaldo: llevar al bloque de compra (product-template) donde vive el botón de Releasit.
        var box = document.querySelector('[id^="shopify-section"][id$="__main"], #shopify-section-main');
        if (box) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  function initFaqSingleOpen() {
    var items = document.querySelectorAll('.rc-sf-faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  function init() {
    initSticky();
    initBuy();
    initFaqSingleOpen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
